import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

function obtenerFechaEnEspañol() {
    const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]
    const hoy = new Date()
    return `Ciudad de México, a ${hoy.getDate()} de ${meses[hoy.getMonth()]} de ${hoy.getFullYear()}`
}
function formatearMoneda(valor) {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    }).format(valor)
}

function agregarPiePagina(doc) {
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    const margin = 20
    const y = pageHeight - 25 // 30 mm desde el borde inferior

    doc.setFontSize(7)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(100)

    const pieTexto = [
        'contacto@arrendafit.com',
        'www.arrendafit.com',
        'T. (55) 70.98.01.70',
        'CALLES OSLO No. EXTERIOR 4, No. INTERIOR',
        'CUAUHTEMOC, JUAREZ',
        'CP 06600 CIUDAD DE MEXICO'
    ]

    pieTexto.forEach((linea, i) => {
        doc.text(linea, pageWidth - margin, y + i * 4, { align: 'right' })
    })
}


const generarCotizacionPDF = async (logoBase64, objeto) => {
    return new Promise((resolve, reject) => {
        const doc = new jsPDF({
            unit: 'mm',
            format: 'letter' // Tamaño carta
        })

        const pageWidth = doc.internal.pageSize.getWidth()
        const margin = 20
        const anchoTexto = pageWidth - 2 * margin
        const lineHeight = 4
        let y = 5

        if (logoBase64) {
            const imgProps = doc.getImageProperties(logoBase64)
            const imgWidth = 30
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width
            doc.addImage(logoBase64, 'PNG', pageWidth - imgWidth - margin, y, imgWidth, imgHeight)
        }

        // 📅 Fecha centrada
        doc.setFontSize(11)
        doc.setFont('helvetica', 'normal')
        doc.text(obtenerFechaEnEspañol(), pageWidth / 2, y + 15, { align: 'center' })
        y += 25

        // 🙋 Nombre a la izquierda
        doc.setFont('helvetica', 'bold')
        doc.text('Atención:', margin, y)
        doc.setFont('helvetica', 'normal')
        doc.text(objeto.cliente, margin, y += 5)
        y += 10

        // 📝 Texto justificable
        doc.setFontSize(10)
        const texto1 = 'Por medio de la presente ponemos a su amable consideración nuestra propuesta comercial sobre la unidad de su interés'
        const texto2 = 'Staff Captación es una empresa creada en 1990 dedicada al arrendamiento puro de bienes muebles con más de 10 años de experiencia, proporcionando a las empresas una opción rápida para la renovación de sus activos.'

        const texto3 = 'Beneficios del Arrendamiento Puro:'
        const texto4 = '• Renta deducible de impuestos'
        const texto5 = '• IVA acreditable y sujeto a devolución en su caso'
        const texto6 = '• No forma parte de los pasivos de la empresa, por lo tanto no afecta su capacidad crediticia'
        const texto7 = '• Fácil registro contable'
        const texto8 = '• Permite las deducciones más aceleradas'
        const texto9 = '• La empresa no se descapitaliza al realizar bajas inversiones iniciales.'

        const texto10 = 'En Staff Captación nos preocupamos por la planeación financiera de su empresa y por ofrecerle los mejores beneficios fiscales, así como presupuestar de manera eficiente los gastos de su negocio.'
        const texto11 = 'Nuestros vehículos incluyen la garantía de la propia marca.'
        const texto12 = 'El seguro es aproximado puede variar al momento de la contratación.'

        const agente = objeto.agente
        const cliente = objeto.cliente
        const vehiculo = objeto.vehiculo
        const precio = objeto.precio
        const anticipo = objeto.anticipo
        const seguro = objeto.seguro
        const total = objeto.preciototal


        // Divide el texto en líneas que se ajusten al ancho
        const lineas = doc.splitTextToSize(texto1, anchoTexto)
        const lineas2 = doc.splitTextToSize(texto2, anchoTexto)
        const lineas3 = doc.splitTextToSize(texto3, anchoTexto)
        const lineas4 = doc.splitTextToSize(texto4, anchoTexto)
        const lineas5 = doc.splitTextToSize(texto5, anchoTexto)
        const lineas6 = doc.splitTextToSize(texto6, anchoTexto)
        const lineas7 = doc.splitTextToSize(texto7, anchoTexto)
        const lineas8 = doc.splitTextToSize(texto8, anchoTexto)
        const lineas9 = doc.splitTextToSize(texto9, anchoTexto)
        const lineas10 = doc.splitTextToSize(texto10, anchoTexto)
        const lineas11 = doc.splitTextToSize(texto11, anchoTexto)
        const lineas12 = doc.splitTextToSize(texto12, anchoTexto)

        // Dibuja línea por línea de forma manual
        lineas.forEach(linea => {
            doc.text(linea, margin, y, { align: 'justify' })
            y += lineHeight
        })

        lineas2.forEach(linea => {
            doc.text(linea, margin, y, { align: 'justify' })
            y += lineHeight
        })
        lineas3.forEach(linea => {
            doc.text(linea, margin, y += 3, { align: 'justify' })
            y += lineHeight
        })
        lineas4.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas5.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas6.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas7.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas8.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas9.forEach(linea => {
            doc.text(linea, margin + 5, y, { align: 'justify' })
            y += lineHeight
        })
        lineas10.forEach(linea => {
            doc.text(linea, margin, y, { align: 'justify' })
            y += lineHeight
        })

        doc.setFontSize(13)
        doc.setFont('helvetica', 'bold')
        doc.text(vehiculo, pageWidth / 2, y += 7, { align: 'center' })
        doc.setFontSize(11)
        doc.text(formatearMoneda(precio), pageWidth / 2, y += 4, { align: 'center' })

        doc.setFontSize(11)
        doc.setFont('helvetica', 'normal')
        lineas11.forEach(linea => {
            doc.text(linea, margin, y += 7, { align: 'justify' })
            y += lineHeight
        })
        doc.setFont('helvetica', 'bold')
        lineas12.forEach(linea => {
            doc.text(linea, margin, y, { align: 'justify' })
            y += lineHeight
        })

        doc.setFontSize(12)
        doc.setFont('helvetica', 'bold')
        doc.text('COTIZADOR DE ARRENDAMIENTO 2024', pageWidth / 2, y += 3, { align: 'center' })

        doc.setFontSize(11)
        doc.setFont('helvetica', 'normal')
        doc.text('Agente', margin, y += 5, { align: 'left' })
        doc.text(agente, pageWidth - margin, y, { align: 'right' })
        doc.setLineWidth(0.08)
        doc.setDrawColor(200)
        doc.line(margin, y + 1, pageWidth - margin, y + 1)

        doc.text('Cliente', margin, y += 5, { align: 'left' })
        doc.text(cliente, pageWidth - margin, y, { align: 'right' })
        doc.line(margin, y + 1, pageWidth - margin, y + 1)

        doc.text('Vehiculo', margin, y += 5, { align: 'left' })
        doc.text(vehiculo, pageWidth - margin, y, { align: 'right' })
        doc.line(margin, y + 1, pageWidth - margin, y + 1)

        doc.text('Precio 1:', margin, y += 5, { align: 'left' })
        doc.text(formatearMoneda(precio), pageWidth - margin, y, { align: 'right' })
        doc.line(margin, y + 1, pageWidth - margin, y + 1)

        doc.text('Anticipo:', margin, y += 5, { align: 'left' })
        doc.text(formatearMoneda(anticipo), pageWidth - margin, y, { align: 'right' })
        doc.line(margin, y + 1, pageWidth - margin, y + 1)

        doc.setFont('helvetica', 'bold')
        doc.text('PRECIO TOTAL (IVA Incluido):', margin, y += 5, { align: 'left' })
        doc.text(formatearMoneda(total), pageWidth - margin, y, { align: 'right' })
        doc.line(margin, y + 1, pageWidth - margin, y + 1)


        // Título de la tabla
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(12)
        doc.setTextColor(0)
        doc.text(objeto.plazo + ' PLAZOS', pageWidth / 2, y += 6, { align: 'center' })

        // Definir color principal azul
        const azul = [0, 148, 202]

        // Definir contenido
        const tablaDatos = [
            ['RENTA MENSUAL', formatearMoneda(objeto.rentamensual)],
            ['IVA', formatearMoneda(objeto.iva)],
            ['RENTA MENSUAL TOTAL', formatearMoneda(objeto.rentamensualtotal)]  // Esta es la que resaltaremos
        ]
        // Dibujar la tabla
        autoTable(doc, {
            head: [['CONCEPTO', 'MENSUALIDADES']],
            body: tablaDatos,
            startY: y + 2,
            margin: { left: margin, right: margin },
            headStyles: {
                fillColor: azul,
                textColor: 255,
                fontStyle: 'bold',
                halign: 'center'
            },
            bodyStyles: {
                textColor: 50,
                halign: 'left',
                fontSize: 9
            },
            columnStyles: {
                1: { halign: 'right' } // 👉 segunda columna (index 1) alineada a la derecha
            },
            styles: {
                lineColor: 200,
                lineWidth: 0.1,
                cellPadding: .5
            },
            didParseCell: function (data) {
                if (data.row.index === 2) { // Fila 2 → "TOTAL"
                    data.cell.styles.fillColor = [240, 240, 240] // gris claro
                    data.cell.styles.fontStyle = 'bold'
                }
            }
        })

        const pagosIniciales = [
            ['ANTICIPO A RENTAS', formatearMoneda(anticipo)],
            ['SEGURO', formatearMoneda(seguro)],
            ['COMISIÓN POR APERTURA', formatearMoneda(objeto.comisionxapertura)],
            ['DEP. EN GARANTÍA Y RENTA ADELANTADA', formatearMoneda(objeto.depgarantiarentaadelantada)],
            ['EMPLACAMIENTO', formatearMoneda(objeto.placas)],
            ['PAGO INICIAL TOTAL', formatearMoneda(objeto.pagoinicialtotal),]
        ]

        autoTable(doc, {
            body: pagosIniciales,
            startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : y + 5,
            margin: { left: margin, right: margin },
            showHead: 'never', // sin encabezado
            styles: {
                fontSize: 9,
                cellPadding: 1,
                lineColor: 200,
                lineWidth: 0.1
            },
            columnStyles: {
                1: { halign: 'right' }  // segunda columna alineada a la derecha
            },
            didParseCell(data) {
                if (data.row.index === pagosIniciales.length - 1) {
                    data.cell.styles.fillColor = [240, 240, 240] // gris claro
                    data.cell.styles.fontStyle = 'bold'
                }
            }
        })

        const valorResidual = [
            ['VALOR RESIDUAL CON I.V.A.', formatearMoneda(objeto.valorresidual)]
        ]

        autoTable(doc, {
            body: valorResidual,
            startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : y + 5,
            margin: { left: margin, right: margin },
            showHead: 'never',
            styles: {
                fontSize: 9,
                cellPadding: 1,
                lineColor: 200,
                lineWidth: 0.1
            },
            columnStyles: {
                1: { halign: 'right' }  // Alinea la segunda columna a la derecha
            }
        })

        agregarPiePagina(doc)

        const base64 = doc.output('datauristring');
        resolve(base64);

        // doc.save('cotizacion.pdf')
        // return doc
    });
};

export { generarCotizacionPDF };
